{
  "feeGrid": {
    "defaultFeeGridFor": "Grille tarifaire par défaut pour",
    "default": {
      "feeGridOrg": "Organisation de la grille tarifaire {{org}}",
      "defaultName": "Frais Nom de la grille : {{name}}",
      "defaultType": "Frais Type de grille : ",
      "parentDefault": "Défaut"
    },
    "table": {
      "name": "Nom",
      "type": "Type",
      "default": "Défaut",
      "state": "État",
      "active": "Actif",
      "inactive": "Inactif",
      "flat": "Plat",
      "blendedGrid": "Tiercé - Mélangé",
      "volumeGrid": "Étagé - Volume",
      "organization": "Organisation"
    },
    "delete": {
      "confirmationTitle": "Supprimer la grille tarifaire",
      "confirmationMessage": "Êtes-vous sûr de vouloir supprimer cette grille tarifaire?"
    },
    "edit": {
      "title": "Supprimer la grille tarifaire",
      "updatedToastMessage": "La grille tarifaire a été mise à jour.",
      "deletedToastMessage": "La grille tarifaire a été mise à jour.",
      "name": "Nom",
      "type": {
        "label": "Type",
        "tooltip": "Fixe - le taux spécifié est appliqué quel que soit l'encours facturable. \nPar paliers - des taux spécifiques sont appliqués aux différents niveaux d'encours facturables.",
        "flat": "Plat",
        "tiered": "Tiercé"
      },
      "flatAnnualFeeBpsLabel": "Redevance annuelle forfaitaire BPS",
      "grid": {
        "to": "à",
        "minAmount": "Minimum",
        "maxAmount": "Maximum",
        "above": "Au-dessus",
        "annualFeeBps": "Redevance annuelle forfaitaire BPS",
        "annualFeeCents": "Frais annuel",
        "type": {
          "label": "Type de grille",
          "tooltip": "Grille de frais mixtes - les différents niveaux d'actifs sont facturés à leurs propres taux de frais spécifiques. Par exemple, votre premier million de dollars est facturé à 1,5 % et les fonds compris entre 1 et 2 millions de dollars sont facturés à 1,25 %.\n Grille de frais de volume - les frais pour l'ensemble de votre portefeuille sont facturés à un certain taux. Par exemple, si votre portefeuille est inférieur à 1 million de dollars, vos frais peuvent être de 1,5 %, mais si votre portefeuille est compris entre 1 et 2 millions de dollars, vous pouvez payer des frais de 1,25 % pour tous les fonds.",
          "blended": "Mélangé",
          "volume": "Volume"
        }
      },
      "chargeForCash": {
        "label": "Solde de trésorerie inclus dans l'encours facturable"
      },
      "chargeForCashOnHold": {
        "label": "Solde de trésorerie inclus dans l'encours facturable"
      },
      "default": {
        "label": "Grille tarifaire par défaut",
        "tooltip": "Cette grille tarifaire sera automatiquement appliquée à un ménage ou à un client si aucune grille tarifaire n'a été définie. Il ne peut y avoir qu'une seule grille tarifaire par défaut.",
        "defaultFlagTooltip": "Il ne peut y avoir qu'une seule grille tarifaire par défaut active. Supprimez l'indicateur de défaut de la grille tarifaire par défaut active existante."
      },
      "gridScope": {
        "label": "Calculer l'AUM facturable en fonction de",
        "tooltip": "Si un sous-compte ne fait pas partie du regroupement sélectionné, la facturation revient à la stratégie de regroupement inférieure suivante : Groupe de comptes → Ménage → Utilisateur."
      },
      "billableAumInclude": {
        "title": "Inclusion des AUM facturables"
      }
    },
    "new": {
      "title": "Nouvelle grille tarifaire",
      "createdToastMessage": "La grille tarifaire a été créée."
    },
    "inherited": "Héritée (Organisation par défaut)",
    "inheritedWithFeeTier": "Héritée ({{applicableFeeTier}})",
    "inheritedWithApplicableBillingSchedule": "Héritée ({{applicableBillingSchedule}})",
    "errors": {
      "noDefaultFound": "Aucune grille tarifaire par défaut trouvée. Veuillez en sélectionner une.",
      "multipleDefaultsFound": "Plusieurs grilles tarifaires par défaut trouvées ({{grid_names}}). Veuillez n'en sélectionner qu'une seule."
    },
    "gridScopeType": {
      "USER": "Utilisateur",
      "CLIENT_GROUP": "Ménage",
      "ACCOUNT_GROUP": "Groupe de comptes",
      "SUB_ACCOUNT": "Sous-compte"
    }
  },
  "billingCycle": {
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "billingDate": "Date de facturation",
    "calculationDate": "Date de calcul",
    "collectedFees": "Redevances perçues",
    "projectedFeeAndTax": "Frais et taxes projetés",
    "totalFeesAndTax": "Total des frais et taxes",
    "organization": "Organisation",
    "billableAumLastDay": "AUM facturable Dernier jour",
    "billableAumWithReductionsApplied": "Réductions appliquées",
    "accruedFees": "Frais courus",
    "salesTax": "Taxe de vente",
    "state": "État",
    "PROCESSED": "Traité",
    "APPROVED": "Approuvé",
    "AWAITING_REVIEW": "Examiner",
    "CYCLE_IN_PROGRESS": "Cycle en cours",
    "CYCLE_COMPLETED": "Cycle complété",
    "baseCurrency": "Devise"
  },
  "billingSchedule": {
    "defaultBillingScheduleFor": "Calendrier de facturation par défaut pour",
    "default": {
      "billingScheduleOrg": "Calendrier de facturation Organisation : {{org}}",
      "defaultFrequency": "Se répète : {{frequency}}",
      "parentNextCalculationDate": "Prochaine date de calcul: {{nextCalculationDate}}",
      "parentNextBillingDate": "Prochaine date de facturation: {{nextBillingDate}}",
      "parentDefault": "Défaut"
    },
    "table": {
      "frequency": "Répétitions",
      "default": "Défaut",
      "state": "État",
      "nextCycle": "Prochain cycle de facturation",
      "nextCalculationDate": "Prochaine date de calcul",
      "nextBillingDate": "Prochain date de facturation",
      "active": "Actif",
      "inactive": "Inactif",
      "organization": "Organisation"
    },
    "edit": {
      "title": "Mise à jour du calendrier de facturation",
      "updatedToastMessage": "Le calendrier de facturation a été mis à jour.",
      "deletedToastMessage": "Le calendrier de facturation a été supprimé.",
      "frequency": "Fréquence",
      "frequencyLabel": "Calculer les frais tous les",
      "default": {
        "label": "Calendrier de facturation par défaut",
        "tooltip": "Cette grille d'honoraires sera automatiquement appliquée à un ménage ou à un client si aucune grille d'honoraires n'a été définie. Il ne peut y avoir qu'une seule grille d'honoraires par défaut.",
        "defaultFlagTooltip": "Il ne peut y avoir qu'une seule grille d'honoraires par défaut active. Supprimez l'indicateur de défaut de la grille d'honoraires par défaut active existante."
      },
      "disclaimerPart1": "Les frais sont calculés du 1er au dernier jour du cycle (mois, trimestre, etc.) et sont facturés au client lors du cycle de facturation suivant.",
      "disclaimerPart2": "Les frais pour ce cycle de facturation de {{startDate}} à {{endDate}} seront calculés à {{nextCalculationDate}} et facturés à {{nextBillingDate}}.",
      "calculationDate": "Date de calcul",
      "billingDate": "Date de facturation",
      "calcDateMustBePastBillingDate": "La date de calcul ne doit pas être postérieure à la date de facturation"
    },
    "new": {
      "title": "Nouveau Calendrier de facturation",
      "createdToastMessage": "Le calendrier de facturation a été créé.",
      "suffix": "jour du mois"
    },
    "delete": {
      "confirmationTitle": "Supprimer le calendrier de facturation",
      "confirmationMessage": "Êtes-vous sûr de vouloir supprimer ce calendrier de facturation ?"
    },
    "frequencies": {
      "MONTHLY": "Mensuel",
      "QUARTERLY": "Trimestriel",
      "SEMESTRAL": "Semestriel",
      "ANNUAL": "Annuel"
    },
    "modelName": "calendrier de facturation",
    "errors": {
      "noDefaultFound": "Aucun calendrier de facturation par défaut trouvé. Veuillez en sélectionner un.",
      "multipleDefaultsFound": "Plusieurs calendriers de facturation par défaut trouvés ({{schedule_names}}). Veuillez n'en sélectionner qu'un seul."
    }
  },
  "feeReport": {
    "exportTitle": "Facturation",
    "exportTypeDaily": "Quotidien",
    "exportTypeCycle": "Cycle",
    "exportProgressTitle": "Exportation de la facturation",
    "refreshSubAccountBillingTotals": "Actualiser les totaux de facturation",
    "exportHeaders": {
      "billingCycleId": "Identifiant du cycle de facturation",
      "date": "Date",
      "clientId": "Identifiant du client",
      "clientFirstName": "Prénom du client",
      "clientLastName": "Nom de famille du client",
      "clientProvince": "Province du client",
      "entityName": "Nom de l'entité du client",
      "accountId": "Identifiant du compte",
      "accountType": "Type de compte",
      "accountNumber": "Numéro de compte",
      "subAccountId": "Identifiant du sous-compte",
      "subAccountName": "Nom du sous-compte",
      "goalId": "Identifiant de l'objectif",
      "goalName": "Nom de l'objectif",
      "aum": "AUM ($)",
      "billableAum": "AUM facturables ($)",
      "cash": "Argent ($)",
      "householdAum": "AUM de ménage ($)",
      "gridScopeTotalMarketValueType": "Niveau total des actifs sous gestion par tranche",
      "gridScopeTotalMarketValueCents": "Grille à plusieurs niveaux Total des actifs sous gestion (en dollars)",
      "annualFeeBPS": "Redevance annuelle forfaitaire BPS",
      "dailyFeeBPS": "Frais journaliers BPS",
      "dailyFee": "Frais journaliers ($)",
      "organizationId": "ID d'organisation",
      "organizationName": "Nom de l'organisation",
      "feePaymentAccountId": "Identifiant du compte de paiement des frais",
      "billingCycleState": "État du cycle de facturation",
      "billingCycleStartDate": "Date de début du cycle de facturation",
      "billingCycleEndDate": "Date de fin du cycle de facturation",
      "billingCycleSalesTax": "Taxe de vente ($)",
      "projectedFeeAndTax": "Frais et taxes projetés",
      "feeGridId": "Identifiant de la grille tarifaire",
      "feeGridName": "Nom de la grille tarifaire",
      "feeTierSource": "Source de la grille tarifaire",
      "accountGroupId": "Identifiant du groupe de comptes",
      "accountGroupName": "Nom du groupe de comptes",
      "currency": "Devise",
      "fxRate": "Taux de change",
      "billableAumLastDayDollars": "AUM facturable dernier jour ($)",
      "aumNetOfReductionsLastDayDollars": "AUM net des réductions dernier jour ($)",
      "billingScheduleFrequency": "Fréquence du calendrier de facturation",
      "cashLastDayDollars": "Trésorerie dernier jour ($)",
      "accruedFees": "Frais courus",
      "totalFeesAndTax": "Total des frais et taxes",
      "salesTax": "Taxe de vente ($)",
      "gst": "TPS ($)",
      "hst": "TVH ($)",
      "pst": "TVP ($)",
      "qst": "TVQ ($)",
      "portfolio": "Portefeuille"
    },
    "filters": {
      "billingDateFrom": "Date de facturation - Du",
      "billingDateTo": "Date de facturation - à"
    },
    "table": {
      "client": "Client",
      "organization": "Organisation",
      "billingSchedule": "Calendrier de facturation",
      "billingDate": "Date de facturation",
      "feeGrid": "Grille tarifaire",
      "from": "De",
      "to": "À",
      "billableAumLastDay": "AUM facturable Dernier jour",
      "billableAumWithReductionsApplied": "Réductions appliquées",
      "accuredFees": "Frais courus",
      "adjustedAccuredFees": "Frais courus ajustés",
      "salesTax": "Taxe de vente",
      "totalFeesAndTax": "Total des frais et taxes",
      "projectedFeeAndTax": "Frais et taxes projetés",
      "cashAvailable": "Trésorerie disponible",
      "feePaymentAccount": "Compte de paiement des frais",
      "currency": "Devise",
      "refreshSubAccountBillingTotalsInfo": "Frais de facturation : {{feeCents}} ({{taxCents}} de taxe) et Total des frais de facturation quotidiens : {{totalDailyFeeCents}} (hors taxe) sont différents.",
      "refreshSubAccountBillingTotalsNote": "Remarque : si la dérogation aux frais a été définie, elle doit être désactivée.",
      "accountGroup": "Groupe de comptes",
      "fxRate": "Taux de change"
    },
    "feeTierSource": {
      "SUB_ACCOUNT": "Sous-compte",
      "ACCOUNT": "Compte",
      "USER": "Client",
      "CLIENT_GROUP": "Ménage",
      "ORGANIZATION": "Organisation",
      "PARENT_ORGANIZATION": "Organisation parente"
    },
    "billingScheduleSource": {
      "SUB_ACCOUNT": "Sous-compte",
      "ACCOUNT": "Compte",
      "USER": "Client",
      "CLIENT_GROUP": "Ménage",
      "ORGANIZATION": "Organisation",
      "PARENT_ORGANIZATION": "Organisation parente"
    },
    "feeTierSourceFrom": "De : {{level}}",
    "billingScheduleSourceFrom": "De : {{level}}",
    "approveBillingCycleConfirmationDialog": {
      "title": "Approuver le cycle de facturation",
      "text": "Êtes-vous sûr de vouloir approuver ce calendrier de facturation ?",
      "toastMessage": "Le cycle de facturation a été approuvé",
      "approve": "Approuver"
    },
    "dailyFee": {
      "feeGrid": "Grille tarifaire: {{feeGrid}}",
      "billingDate": "Date de facturation: {{billingDate}}",
      "period": "Frais calculés de {{from}} à {{to}}",
      "date": "Date",
      "billableAum": "AUM facturables",
      "dailyFeeBps": "Frais journaliers BPS",
      "dailyFixedFeeCents": "Frais fixes quotidiens",
      "totalDailyFeeCents": "Frais quotidiens courus"
    },
    "overrideFees": {
      "title": "Fixer une taxe dérogatoire",
      "undo": "Annuler l'annulation de la taxe",
      "adjustedFeeCents": "Frais ajustés",
      "adjustedSalesTaxCents": "Taxe ajustée",
      "note": "Note",
      "toastMessage": "Les frais ont été annulés.",
      "undoMessage": "L'annulation des frais a été supprimée.",
      "copyToClient": "Copier dans les notes du client",
      "salesTaxConfigurationError": "Impossible de charger la configuration de la taxe de vente, donc la taxe ajustée ne peut pas être calculée. Veuillez réessayer plus tard."
    }
  }
}
